import { Controller } from "@hotwired/stimulus"

// Basic Modal Controller for ViewComponents
// Handles opening, closing, and backdrop interactions
export default class extends Controller {
  static targets = ["modal"]
  
  connect() {
    // Bind escape key
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape)
  }
  
  // Open modal
  open() {
    const modal = this.element
    modal.classList.remove("hidden")
    
    // Focus management
    modal.focus()
    
    // Prevent body scroll
    document.body.style.overflow = "hidden"
  }
  
  // Close modal
  close() {
    const modal = this.element
    modal.classList.add("hidden")
    
    // Restore body scroll
    document.body.style.overflow = ""
  }
  
  // Close on backdrop click
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
  
  // Close on escape key
  handleEscape(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }
  
  // Static method to open any modal by ID
  static open(modalId) {
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.remove("hidden")
      modal.focus()
      document.body.style.overflow = "hidden"
    }
  }
  
  // Static method to close any modal by ID  
  static close(modalId) {
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }
}